var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"w-full lg:w-96 bg-gray-200 mx-auto my-16 p-16 lg:p-8 rounded-lg"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }